import { Tabs } from "@mantine/core";
import type { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

interface Props {
    text: string;
    activeTab?: string | null;
    icon?: ReactElement;
    numberOfVideos?: string;
    value: string;
}

export default function Tab({ text, activeTab, icon, numberOfVideos, value }: Props) {
    return (
        <Tabs.Tab value={value} disabled={numberOfVideos === "0"}>
            {" "}
            <div>
                <div className="w-auto h-12 px-10 pt-4 -pb-2 justify-center items-center gap-1 inline-flex">
                    <div className="w-6 h-6 justify-center items-center flex">
                        {icon}
                    </div>
                    <div
                        className={twMerge(
                            "text-center text-lg leading-normal",
                            activeTab === value
                                ? "text-teal-500 font-semibold"
                                : "text-zinc-600",
                        )}
                    >
                        {text}
                    </div>
                    <div
                        className={twMerge(
                            "p-1 rounded flex-col justify-start items-start gap-1 inline-flex",
                            activeTab === value
                                ? "bg-teal-100 font-semibold"
                                : "bg-zinc-100",
                        )}
                    >
                        <div className="self-stretch text-neutral-800 text-xs leading-none">
                            {numberOfVideos}
                        </div>
                    </div>
                </div>
            </div>
        </Tabs.Tab>
    );
}
